import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function Activities() {
  const activityArticles = articles.filter((a) => a.category === 'activity').slice(0, 3);

  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            最新活动
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            精彩活动，福利不断
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            关注91牛最新动态和优惠活动，不错过每一个福利机会
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {activityArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3 bg-accent-500 text-background-50 text-xs font-semibold px-3 py-1 rounded-full">
                  活动
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span>{article.date}</span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/category/activity"
            className="whitespace-nowrap inline-flex items-center gap-2 text-primary-600 hover:text-primary-700 font-medium text-sm transition-colors cursor-pointer"
          >
            查看更多活动
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}